// extracted by mini-css-extract-plugin
export var benefits = "benefits-module--benefits--OFLJA";
export var container = "benefits-module--container--jJw1p";
export var metrics = "benefits-module--metrics--Dk-BK";
export var benefit = "benefits-module--benefit--PR5bW";
export var value = "benefits-module--value--Mv6aA";
export var lineMove = "benefits-module--lineMove--qzrHo";